import { Utils } from "@/plugins/utils";
import moment from 'moment';
const ScanErro = require('../../../public/audio/ScanErro.wav')

export default {
    namespaced: true,
    state: {
        lstOfq: [],
        ofq: {},
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        hasNext: false,
        lastUpdatedRegister: null
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getInsert(state) {
            return state.insert
        },
        getOfq(state) {
            let ofq = { ...state.ofq }
            ofq.ofqfim = ofq.ofqfim ? ofq.ofqfim : moment().format("9999-12-31T23:59")
            return ofq
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        },
        isFillingStarted: (state) => {
            if (!state.ofq || !state.ofq.ofqinicio)
                return false

            const data = new Date(state.ofq.ofqinicio)
            if (isNaN(data)) return false

            return data.getFullYear() !== 1899
        },

        isFillingClosed: (state) => {
            if (!state.ofq || !state.ofq.ofqfim)
                return false

            const data = new Date(state.ofq.ofqfim)
            if (isNaN(data)) return false

            return data.getFullYear() !== 9999
        }

    },
    mutations: {
        set(state, ofq) {
			state.ofq = { ...ofq }
            if (ofq)
                state.update = true
		},
        initForm(state) {
            state.insert = false
            state.update = false
            state.ofq = {}
        },
        setParamsDataTable(state, payload) {
            state.lstOfq = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setOfq(state, ofq) {
            state.ofq = ofq
        },
        setLstOfq(state, lstOfq) {
            state.lstOfq = lstOfq
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, ofqenchim) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Oryxplace/Filling/Find/${ofqenchim}`)
                .then(response => {
                    let ofq = Utils.ValidateAxiosResponse(response.data);
                    commit("set", ofq)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async get({ dispatch }, ofqenchim) {
            return await this._vm.$axios.get(`/Oryxplace/Filling/Find/${ofqenchim}`)
            .then(response => {
                return Utils.ValidateAxiosResponse(response.data);
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return null
            });
        },
        async save({ getters, dispatch }) {
            if (!getters.getInsert) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/OryxPlace/Filling/Insert", getters.getOfq)
                .then(response => {
                    let ofq = Utils.ValidateAxiosResponse(response.data);
                    commit('setLastUpdatedRegister', ofq);
                    commit("set", ofq)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }) {

            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Oryxplace/Filling/Update", getters.getOfq)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Oryxplace/Filling/Delete/${getters.getOfq.ofqordem}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    window.location.reload(true)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findByOrder({ commit, dispatch }, ofqordem) {
            commit("setLoading", true)
            await this._vm.$axios.get(`/Oryxplace/Filling/FindByOrder/${ofqordem}`)
                .then(response => {
                    let ofq = Utils.ValidateAxiosResponse(response.data);
                    commit("set", ofq)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async findLastFilling({ dispatch }) {
            return await this._vm.$axios.get(`/Oryxplace/Filling/FindLastFilling/`)
                .then(response => {
                    return Utils.ValidateAxiosResponse(response.data);
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return null
                });
        },
        async findPressureClass({ dispatch }, params) {
            var audioErro = new Audio(ScanErro);
            let ofqclapres = params.ofqclapres
            let meaidrecip = params.meaidrecip
            return await this._vm.$axios.get(`/Oryxplace/CylinderFilling/FindPressureClass?ofqclapres=${ofqclapres}&meaidrecip=${meaidrecip}`)
            .then(response => {
                let med = Utils.ValidateAxiosResponse(response.data);
                return med
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                audioErro.play();
            });
        },
    }
}